import { Alert, Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { Formik } from 'formik'
import React, { useState } from 'react'
import { Currency } from '../../../../api/asset-holders/Currency'
import {
  useCreateCurrencyExchangeInstructionMutation
} from '../../../../api/currency-exchanges/currencyExchangeInstructionApi'
import type { LedgerAccountDetails } from '../../../../api/schema-dtos/AssetHolderFinancePayloadDtos'
import type {
  CurrencyExchangeInstructionDetails
} from '../../../../api/schema-dtos/CurrencyExchangeInstructionDomainDtos'
import { RtkQueryHelper } from '../../../../api/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import OtpComponent from '../../../auth/components/OtpComponent'
import { setNotification } from '../../../shared/components/ui-widgets/uiWidgetsSlice'

interface CreateInstructionComponentProps {
  assetHolderId: number
  wallets: LedgerAccountDetails[]
  hasPassedKyc: boolean
  maxCardWidth: number
  existingInstructions: CurrencyExchangeInstructionDetails[]
}

const CreateExchangeInstructionComponent: React.FC<CreateInstructionComponentProps> = ({
  assetHolderId,
  wallets,
  hasPassedKyc,
  maxCardWidth,
  existingInstructions
}: CreateInstructionComponentProps) => {
  const dispatch = useAppDispatch()
  const [openDialog, toggleDialog] = useState<boolean>(false)
  const [apiCreateInstruction, { isLoading }] = useCreateCurrencyExchangeInstructionMutation()

  const zarWallets: LedgerAccountDetails[] = wallets.filter(w => w.availableBalance > 0 && w.currencyCode === Currency.ZAR)

  const handleCreateInstruction = (otp: string): void => {
    apiCreateInstruction({ assetHolderId, otp })
      .unwrap()
      .then(() => {
        dispatch(setNotification({
          open: true,
          severity: 'success',
          message: 'Your ZAR Payout In BTC Instruction has been successfully scheduled. You will also receive a confirmation email.'
        }))
        toggleDialog(false)
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  return (
    <>
      {zarWallets.length === 0 && existingInstructions.length === 0 && (
        <Box>
          <Alert severity="info" sx={{ mt: 3, maxWidth: maxCardWidth - 30, px: 2 }}>
            A ZAR Payout in BTC Instruction can not be created as your ZAR wallet has a zero balance.
          </Alert>
        </Box>
      )}

      {zarWallets.length > 0 && (

        <Button
          variant={'contained'}
          color={'primary'}
          sx={{ mt: 2, mr: 2 }}
          disabled={!hasPassedKyc}
          onClick={() => {
            toggleDialog(true)
          }}
        >
          Schedule a ZAR Payout in BTC.
        </Button>

      )}

      <Dialog
        open={openDialog}
        maxWidth={'md'}
        fullWidth={true}
        disableEscapeKeyDown={true}
        onClose={() => {
          toggleDialog(false)
        }}
        sx={{ p: 2 }}
      >
        <DialogTitle>Schedule a ZAR Payout In BTC Instruction</DialogTitle>

        <DialogContent>
          <Formik
            initialValues={{}}
            onSubmit={(values) => {
            }}
          >
            {formikProps => (
              <form>
                <Grid container spacing={3} sx={{ pt: 2 }}>
                  <Grid item md={12}>
                    <Typography variant={'body1'}>
                      Are you sure you would like to convert your ZAR wallet balance
                      (ZAR {zarWallets[0]?.availableBalanceFormatted}) to BTC?
                    </Typography>

                  </Grid>

                  <Grid item md={12}>
                    <Box display={'flex'} justifyContent={'space-between'}>
                      <OtpComponent
                        assetHolderId={assetHolderId}
                        actionName={'Confirm'}
                        isLoading={isLoading}
                        authenticatorConfigured={null}
                        executeAction={(otp: string) => {
                          handleCreateInstruction(otp)
                        }}
                        disabled={false}
                      />

                      <Button
                        variant={'outlined'}
                        type="button"
                        sx={{ ml: 2 }}
                        onClick={() => {
                          toggleDialog(false)
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default CreateExchangeInstructionComponent
